import {
  AutoUnfollowDashboardRestEndpointService,
  DashboardSettingsService,
  type FanNumberingMaxNumberRequestDto,
  PromotionReactivatorDaysRequestDto,
  type ToggleStateRequestDto,
} from '@api'

import type { SettingsReactivator } from '@/modules/creator-settings/types.ts'

const togglePromotionReactivator = async (
  creatorId: number,
  toggleData: ToggleStateRequestDto,
): Promise<void> => {
  return DashboardSettingsService.apiToggleReactivator({
    creatorId,
    requestBody: toggleData,
  })
}

const setReactivatorDays = async (
  creatorId: number,
  requestData: PromotionReactivatorDaysRequestDto,
): Promise<void> => {
  return DashboardSettingsService.apiSetPromotionReactivatorDays({
    creatorId,
    requestBody: requestData,
  })
}

const toggleFanNumbering = async (
  creatorId: number,
  toggleData: ToggleStateRequestDto,
): Promise<void> => {
  return DashboardSettingsService.apiToggleFanNumbering({
    creatorId,
    requestBody: toggleData,
  })
}

const setFanNumberingMaxNumber = async (
  creatorId: number,
  requestData: FanNumberingMaxNumberRequestDto,
): Promise<void> => {
  return DashboardSettingsService.apiSetFanNumberingMaxNumber({
    creatorId,
    requestBody: requestData,
  })
}

const toggleAutoFollowExpiredFans = async (
  creatorId: number,
  toggleData: SettingsReactivator,
): Promise<void> => {
  return DashboardSettingsService.apiToggleAutoFollow({
    creatorId,
    requestBody: toggleData,
  })
}

const setAutoFollowMinimumSpending = async (
  creatorId: number,
  requestData: number,
): Promise<void> => {
  return DashboardSettingsService.setPriceForAutoFollowExpiredFans({
    creatorId,
    spending: requestData,
  })
}

const updateAutoUnfollowSettings = async (
  creatorId: number,
  data: {
    enabled?: boolean
    spend?: number
    days?: number
  },
): Promise<void> => {
  // BE need to add types
  return AutoUnfollowDashboardRestEndpointService.updateAutoUnfollowSettings({
    creatorId,
    requestBody: data,
  })
}

const toggleAutoUnFollowExpiredFans = async (
  creatorId: number,
  toggleData: SettingsReactivator,
): Promise<void> => {
  return updateAutoUnfollowSettings(creatorId, { enabled: toggleData.state })
}

const setAutoUnFollowMinimumSpending = async (
  creatorId: number,
  requestData: number,
): Promise<void> => {
  return updateAutoUnfollowSettings(creatorId, { spend: requestData })
}

const setAutoUnFollowDays = async (
  creatorId: number,
  requestData: number,
): Promise<void> => {
  return updateAutoUnfollowSettings(creatorId, { days: requestData })
}

export const creatorSettingsService = {
  togglePromotionReactivator,
  setReactivatorDays,
  toggleFanNumbering,
  setFanNumberingMaxNumber,
  toggleAutoFollowExpiredFans,
  setAutoFollowMinimumSpending,
  toggleAutoUnFollowExpiredFans,
  setAutoUnFollowMinimumSpending,
  setAutoUnFollowDays,
}
